// extracted by mini-css-extract-plugin
export default {"subir_video":"SubirVideo_subir_video__q26eG","datos":"SubirVideo_datos__32CyD","cerar":"SubirVideo_cerar__fndOX","cargando":"SubirVideo_cargando__QQ+Cc"};